import React, { Component } from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';

import store from './store';
import BulkUploadLetters from './components/bulk-upload-letters';

export default class extends Component {
	render() {
		return (
			<Provider store={ store }>
				<BulkUploadLetters />
			</Provider>
		);
	}
}
